<template>
  <div class="d-flex flex-column align-items-start">
    <div class="d-flex flex-column align-items-end">
      <table class="table table-sm table-striped" style="width: auto;">
        <tbody>
        <tr v-for="grant in value" :key="grant.client_hash">
          <td class="align-middle p-2"><b-avatar :src="grant.logo_url" size="lg" :text="grant.name.substr(0, 2)" square :variant="null" class="text-primary font-weight-bolder letter-spacing-1px" /></td>
          <td class="align-middle p-2 px-3">{{ grant.name }}</td>
          <td class="align-middle p-2 px-3">
            <button type="button" class="btn btn-iso-unlink"
                    @click="$emit('input', value.filter(g => g !== grant))"><span class="material-icons icon-iso-unlink">link_off</span>
              {{ revokeLabel || 'UNLINK' }}
            </button>
          </td>
        </tr>
        </tbody>
      </table>
      <slot name="buttons"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Grants',
  props: ['revokeLabel', 'value']
}
</script>
